module.exports = __webpack_public_path__ + "static/img/introductions-bg.6d1c1d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/introductions-bg.png
// module id = VnEF
// module chunks = 0